import React from 'react';
import { InputItem } from 'antd-mobile';
import { partial } from 'lodash';
import * as PropTypes from 'prop-types';
import { checkCodeStatus } from '@/constant/common';
import loadingIcon from '@/assets/loading.svg';

import './index.scss';

const INPUT_ID = ['1', '2', '3', '4', '5', '6'];
const INPUT_EDITABLE = {
  [checkCodeStatus.NORMAL]: true,
  [checkCodeStatus.SUCCESS]: false,
  [checkCodeStatus.FAILURE]: true,
  [checkCodeStatus.LOADING]: false,
};

export default class CodeInput extends React.Component {
  static propTypes = {
    loading: PropTypes.bool,
    status: PropTypes.string.isRequired, // checkCodeStatus
  };

  constructor(props) {
    super(props);
    const { successMsg, failMsg } = props;

    this.ele = {}; // input 对象
    this.state = {
      result: new Array(INPUT_ID.length).fill(''), // 初始化结果数组
      tipsJSX: {
        [checkCodeStatus.NORMAL]: '',
        [checkCodeStatus.SUCCESS]: (
          <div className="success-tips">{successMsg}</div>
        ),
        [checkCodeStatus.FAILURE]: <div className="error-tips">{failMsg}</div>,
        [checkCodeStatus.LOADING]: (
          <img className="loading-icon" src={loadingIcon} alt="" />
        ),
      },
    };
  }

  /**
   * 聚焦到下一个空白 input
   * @param {*} currentIndex 当前 input index
   * @memberof CodeInput
   */
  nextBlankInputFocus(currentIndex) {
    const { result } = this.state;
    const inputLen = INPUT_ID.length;

    for (let i = currentIndex; i < inputLen; i++) {
      if (!result[i]) {
        // setTimeout 解决 ios safari 不能聚焦问题
        setTimeout(this.ele[INPUT_ID[i]].focus);
        break;
      }
    }
  }

  /**
   * input 改变事件
   * @param {*} inputIndex 当前 input 索引
   * @param {*} value input 值
   */
  handleInputChange = (inputIndex, value) => {
    const { result } = this.state;
    const { onOk } = this.props;

    // 在非空 input 输入新数值时，跳到下一个
    if (result[inputIndex] && value) {
      return this.nextBlankInputFocus(inputIndex);
    }

    value.length > 1 && (value = value.slice(0, 1)); // 粘贴时读取第一个

    result.splice(inputIndex, 1, value);
    this.setState({
      result,
    });

    // 无值(删除操作)不做处理
    if (!value) {
      return;
    }

    // 全部已填
    if (result.every(Boolean)) {
      return onOk && onOk(result);
    }

    this.nextBlankInputFocus(inputIndex);
  };

  /**
   * 键盘按下事件
   * @param {number} inputIndex 当前 input 索引
   * @param {*} e 按下事件对象
   */
  handleKeyDown = (inputIndex, e) => {
    /*
     * 满足以下条件，聚焦到上一个 input：
     * 1. 按下退格键
     * 2. 当前作用 input 非第一个
     * 3. 当前 input 值为空
     * 4. 后面的所有 input 值为空
     */

    const { result } = this.state;
    if (this.timer) return;

    // 按下退格键 & 当前作用 input 非第一个
    if (e.keyCode === 8 && inputIndex) {
      this.timer = setTimeout(() => {
        // 当前 input 值为空 & 后面的所有 input 值为空
        if (!result.slice(inputIndex).join('').length) {
          this.ele[INPUT_ID[inputIndex - 1]].focus();
        }
        this.timer = null;
      }, 10); // 聚焦行为在 onChange 之后
    }
  };

  render() {
    const { status } = this.props;
    const { tipsJSX, result } = this.state;

    return (
      <div className="code-input-container">
        <div className="code-input">
          {INPUT_ID.map((id, index) => (
            <InputItem
              className="input-item"
              type="number"
              key={id}
              onChange={partial(this.handleInputChange, index)}
              onKeyDown={partial(this.handleKeyDown, index)}
              ref={(ele) => (this.ele[id] = ele)}
              style={{ border: '1px solid', width: '30px' }}
              editable={INPUT_EDITABLE[status]}
              value={result[index]}
              // maxLength={1} 设置为1时，在有内容的input输入数字，不会触发onChange事件
            />
          ))}
        </div>
        {tipsJSX[status] ? (
          <div className="input-tips">{tipsJSX[status]}</div>
        ) : (
          ''
        )}
      </div>
    );
  }
}
